import React, { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CloseIcon from '@mui/icons-material/Close';

function TooltipCheckbox({ checked, onClick }) {
  const [hovered, setHovered] = useState(false);

  return (
    <Checkbox
      disableRipple
      size="small"
      checked={checked}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      icon={<CheckBoxOutlineBlankIcon />}
      checkedIcon={
        hovered ? (
          <Box sx={{ 
            backgroundColor: '#DC2626',
            padding: 0,
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <CloseIcon sx={{ color: 'white', fontSize: 18 }} />
          </Box>
        ) : (
          <CheckBoxIcon />
        )
      }
      sx={{
        padding: 0,
        top: '-2px',
        '& .MuiSvgIcon-root': {
          fontSize: 18,
          width: 18,
          height: 18,
          borderRadius: 1
        }
      }}
    />
  );
}

export default TooltipCheckbox; 